import React, {useRef, useState} from 'react';
import Popup from "reactjs-popup";
import useScroll from "ubs-framework/v2/hooks/useScroll";
import * as Icon from "ubs-icons";
import {COLOR} from "ubs-framework/v2/common/constant";
import UDatePicker from "ubs-framework/v2/UDatePicker";

const DatePickerFilter = React.memo((props) => {
    const popupRef = useRef(null)
    const [name, setName] = useState('')
    const handle = {
        blur: e => {
            if (name) props?.onChange(name)
        },
        change: e => {
            setName(e)
        },
        clearData: e => {
            e.stopPropagation()
            props?.onChange('')
            if (popupRef?.current) popupRef?.current?.open()
        }
    }

    useScroll(document.getElementsByClassName('u_import-scroll')[0], (e) => {
        if (popupRef.current) popupRef.current.close()
    });

    return (
        <React.Fragment>
            <Popup
                ref={popupRef}
                trigger={open => (
                    <div className="u_import-data-input">
                        <p className="u_small-font u_cp  u_flex u_align-center" onClick={(e) => handle.clearData(e)}>
                            <span className="u_mr-5 u_flex-1">{props?.errorTitle || props?.placeholder}</span>
                            <Icon.Calendar fill={COLOR.u_title} size={14}/>
                        </p>
                    </div>
                )}
                position="bottom center"
                closeOnDocumentClick
                closeOnEscape
                className="u_popover-container"
                arrow={false}
                contentStyle={{zIndex: 10001}}
                onClose={handle.blur}
            >
                <div className="u_filter u_filter-date u_filter-white-bg">
                    <UDatePicker
                        selected={name}
                        onChange={(e) => handle.change(e)}
                        maxDate={props?.maxDate ? new Date() : null}
                        showDisabledMonthNavigation
                        placeholderText=" "
                        dateFormat="dd/MM/yyyy"
                        popperPlacement="bottom-end"
                    />
                </div>
            </Popup>
        </React.Fragment>
    );
});

export default DatePickerFilter;
